import { getEnabledEventsForSchedule } from '../config/eventsConfig';

export const SCHEDULE_CONSTANTS = {
  SECTION_TITLE: 'Wedding Events',
  SECTION_ID: 'schedule',
  EVENTS_TITLE_ID: 'events-title',
  DIRECTIONS_TEXT: 'Get Directions',
  
  // Get enabled events from centralized config
  getEnabledEvents: getEnabledEventsForSchedule,
};